import styled from 'styled-components';

// Pilula flutuante no canto inferior-direito. Discreta quando off;
// destacada (laranja) quando o simulador esta ativo — evita esquecer
// que os dados sao fake.
export const Button = styled.button`
  position: fixed;
  right: 16px;
  bottom: 16px;
  z-index: 9000;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 14px;
  border-radius: 999px;
  cursor: pointer;
  font-family: inherit;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.04em;
  transition: background 150ms, color 150ms, box-shadow 150ms,
    border-color 150ms;

  ${(props) =>
    props.$active
      ? `
        background: var(--cco-orange, #f1a25b);
        color: #1a1208;
        border: 1px solid var(--cco-orange, #f1a25b);
        box-shadow: 0 6px 20px rgba(241, 162, 91, 0.45);
      `
      : `
        background: var(--cco-surface, #0e0f12);
        color: var(--cco-ink, #e8eaed);
        border: 1px solid var(--cco-line-strong, rgba(255,255,255,0.22));
        box-shadow: 0 6px 18px rgba(0, 0, 0, 0.5);
      `}

  svg {
    flex-shrink: 0;
  }

  &:hover {
    ${(props) =>
      !props.$active &&
      'color: var(--cco-ink, #e8eaed); border-color: var(--cco-line-strong, rgba(255,255,255,0.24));'}
  }
`;
